<div
    class="satellites"
    fxLayout="column wrap"
    [fxLayoutAlign]="wrap ? 'start start' : 'start stretch'"
    [class.disabled]="disabled"
    [class.wrap]="wrap"
    [class.satellites-maximized]="mapMaximized"
    [class.satellites-minimized]="!mapMaximized"
>
    <div fxFlex class="satellite-area" *ngFor="let satellite of satellites; trackBy: trackBySatellite">
        <mat-card>
            <div
                class="satellite"
                [class.trolley]="satellite.type === 'TROLLEY'"
                [class.standalone]="satellite.type === 'STANDALONE'"
                fxLayout="row"
                fxLayoutAlign="stretch center"
                [style]="satelliteStyle && satelliteStyle[satellite.satelliteId]"
                [class.positioned]="satelliteStyle && satelliteStyle[satellite.satelliteId]"
                [class.right-aligned]="
                    satelliteStyle &&
                    satelliteStyle[satellite.satelliteId] &&
                    satelliteStyle[satellite.satelliteId]['flex-direction'] === 'row-reverse'
                "
            >
                <!-- Satellite icon -->
                <div fxLayout="row" fxLayoutAlign="stretch center" class="satellite-icon" *ngIf="showSatellites">
                    <button
                        mat-icon-button
                        rounded
                        [matTooltip]="satellite.tooltipText"
                        [dialogLink]="
                            satellite.type === 'TROLLEY'
                                ? ['cabinet', satellite.connectors && satellite.connectors[0]?.stationId, 1]
                                : ['satellite', satellite.connectors[0]?.stationId, satellite.satelliteId]
                        "
                    >
                        <label *ngIf="satellite.actualType === 'TROLLEY'" for="trolley-label">M</label>
                        <label class="virtual" *ngIf="satellite.actualType === 'VIRTUAL'" for="virtual-label">VC</label>
                        <label class="standalone" *ngIf="satellite.actualType === 'STANDALONE'" for="ac-label"
                            >AC</label
                        >
                        <div *ngIf="satellite.actualType !== 'UNKNOWN'">
                            <mat-icon *ngIf="satellite.type === 'SATELLITE'" svgIcon="k-satellite"></mat-icon>
                            <mat-icon *ngIf="satellite.type === 'STANDALONE'" svgIcon="k-charging-satellite"></mat-icon>
                            <mat-icon *ngIf="satellite.type === 'TROLLEY'" svgIcon="k-trolley-small"></mat-icon>
                        </div>
                        <mat-icon
                            class="big"
                            *ngIf="satellite.actualType === 'UNKNOWN'"
                            svgIcon="ev-station-alt"
                        ></mat-icon>
                    </button>
                </div>

                <div fxLayout="row" fxLayoutAlign="stretch center" class="satellite-icon" *ngIf="!showSatellites">
                    <mat-icon class="big" svgIcon="ev-station-alt" [matTooltip]="satellite.tooltipText"></mat-icon>
                </div>

                <!-- Connectors -->
                <div fxFlex class="connectors" fxLayout="column">
                    <div *ngFor="let connector of satellite.connectors; trackBy: trackByConnector" fxLayout="row">
                        <!-- Charging priority indicator -->
                        <div class="charging-priority-container" *ngIf="prioritySetForAnyConnector">
                            <div
                                class="charging-priority"
                                [matTooltip]="getChargingPriorityToolTip(connector.chargingPriority)"
                                *ngIf="connector.chargingPriority"
                            >
                                <mat-icon class="charging-priority-icon">{{
                                    connector.chargingPriority > 0
                                        ? 'keyboard_arrow_up'
                                        : connector.chargingPriority < 0
                                          ? 'keyboard_arrow_down'
                                          : ''
                                }}</mat-icon>
                            </div>
                        </div>

                        <div
                            class="connector"
                            fxLayout="row"
                            fxLayoutAlign="stretch center"
                            [class.available]="connector | isAvailable"
                            [class.faulted]="connector | isFaulted"
                            [class.occupied]="connector | isOccupied"
                            [class.preparing]="connector | isPreparing"
                            [class.charging]="connector | isCharging"
                            [class.finishing]="connector | isFinishing"
                            [class.self-test]="connector | isSelfTest"
                            [class.hl]="
                                compareSubjectToConnector(stations.highlightedEvse$ | async, {
                                    stationId: connector?.stationId,
                                    evseId: connector.evseId,
                                })
                            "
                            [class.hlTx]="(stations.highlightedTxId$ | async) === connector?.tx?.txId"
                        >
                            <!-- Evse name / ID -->
                            <div
                                class="pill-button"
                                mat-ripple
                                [dialogLink]="['connector', connector.stationId, connector.evseId]"
                                [matTooltip]="
                                    connectorText +
                                    ' ' +
                                    connector.evseId +
                                    ' - ' +
                                    (connector?.evseType || '') +
                                    ' ' +
                                    (connector.maxPowerKw ? connector.maxPowerKw + ' kW' : '')
                                "
                                (mouseenter)="setActiveTx(connector)"
                                (mouseleave)="setActiveTx(null)"
                            >
                                {{ connector.evseName || connector.evseId }}
                                {{
                                    connector.chargingPriority > 0
                                        ? '[High]'
                                        : connector.chargingPriority < 0
                                          ? '[Low]'
                                          : ''
                                }}
                            </div>
                            <!-- Transaction details - short version (car icon) -->
                            <div
                                class="tx-simplified"
                                fxLayout="column"
                                *ngIf="connector?.tx && (connector | isOccupied) && !displayTxInline"
                                [dialogLink]="['tx', connector.tx.txId]"
                                (mouseenter)="setActiveTx(connector)"
                                (mouseleave)="setActiveTx(null)"
                            >
                                <mat-icon class="ev" svgIcon="k-ev"></mat-icon>
                            </div>

                            <!-- Transaction details -->
                            <div
                                class="tx"
                                fxLayout="column"
                                *ngIf="connector?.tx && (connector | isOccupied)"
                                [dialogLink]="['tx', connector.tx.txId]"
                                [class.displayTxInline]="displayTxInline"
                                (mouseenter)="setHighlightTx(connector)"
                                (mouseleave)="setHighlightTx(null)"
                            >
                                <div
                                    class="ev ev-container"
                                    *ngIf="evDisplayNameByConnector[connector.stationId + connector.evseId]"
                                >
                                    <span [ngClass]="{ 'ev-name': connector.tx | scheduledDepartureTime }">
                                        {{ evDisplayNameByConnector[connector.stationId + connector.evseId] }}
                                    </span>
                                    <!-- Scheduled departure time -->
                                    <ng-container *ngIf="connector.tx | scheduledDepartureTime">
                                        <ng-container
                                            *ngTemplateOutlet="scheduledDeparture; context: { $implicit: connector }"
                                        >
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <div class="tx-details">
                                    <ng-container
                                        *ngTemplateOutlet="chargingContainer; context: { $implicit: connector }"
                                    >
                                    </ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="preparingContainer; context: { $implicit: connector }"
                                    >
                                    </ng-container>
                                    <ng-container
                                        *ngTemplateOutlet="finishingContainer; context: { $implicit: connector }"
                                    >
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
</div>

<ng-template #preparingContainer let-connector>
    <ng-container *ngIf="connector | isPreparing">
        <span i18n="Connector status|">PREPARING</span>
        <ng-container *ngIf="connector.tx.soc">
            , <b>{{ connector.tx.soc }}</b> %
        </ng-container>
        <ng-container *ngIf="connector.tx.totalCostCents != null">
            <ng-container *ngIf="connector.tx.soc">, </ng-container>
            <b>{{ connector.tx.totalCostCents / 100 | number: '0.2-2' | currency: connector.tx.paymentCurrency }}</b>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #finishingContainer let-connector>
    <ng-container *ngIf="connector | isFinishing">
        <span i18n="Connector status|">FINISHING</span>
        <ng-container *ngIf="connector.tx.soc">
            , <b>{{ connector.tx.soc }}</b> %, +<b>{{ connector.tx.chargedEnergyKwh | number: '1.1-1' }}</b> kWh
        </ng-container>
        <ng-container *ngIf="connector.tx.totalCostCents != null">
            <ng-container *ngIf="connector.tx.soc">, </ng-container>
            <b>{{ connector.tx.totalCostCents / 100 | number: '0.2-2' | currency: connector.tx.paymentCurrency }}</b>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #chargingContainer let-connector>
    <ng-container *ngIf="connector | isCharging">
        <b>{{ connector.tx.powerKw | number: '1.0-0' }}</b> kW<ng-container *ngIf="connector.tx.soc != null"
            >, <b>{{ connector.tx.soc }}</b> %
        </ng-container>
        <ng-container *ngIf="connector.tx.chargedEnergyKwh >= 0"
            >, +<b>{{ connector.tx.chargedEnergyKwh | number: '1.1-1' }}</b> kWh</ng-container
        >
        <ng-container *ngIf="connector.tx.totalCostCents != null">
            <ng-container *ngIf="connector.tx.soc">, </ng-container>
            <b>{{ connector.tx.totalCostCents / 100 | number: '0.2-2' | currency: connector.tx.paymentCurrency }}</b>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #scheduledDeparture let-connector>
    <div
        class="schedule"
        [matTooltip]="vehicleScheduledDepartureText + ' ' + (connector.tx | scheduledDepartureTime: true)"
    >
        <span class="diamond"></span>
        {{ connector.tx | scheduledDepartureTime }}
        <ng-container *ngIf="connector.tx?.schedulePlan?.targetSoC">
            <span class="target-soc-icon">&#9658;</span>
            {{ connector.tx.schedulePlan.targetSoC }}%
        </ng-container>
    </div>
</ng-template>
